import { PERMISSIONS_API } from '@Constants/backendConstants';
import { type ApiBranding } from '@Model';
import { type Result } from '@synqo/frontend-component-library';
import { type CustomDomainState } from './CustomDomainState';

export const CUSTOM_DOMAIN_BRANDING_URL = `${PERMISSIONS_API}/branding`;

export const CUSTOM_DOMAIN_BRANDING_TIMEOUT_MS = 3000;

// @ai-generated 2026-10-12T14:25:59+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** Loads the branding of the requested host. Falls back to the default look and login on timeout or error. */
export async function loadCustomDomainBranding(
    timeoutMs = CUSTOM_DOMAIN_BRANDING_TIMEOUT_MS,
): Promise<CustomDomainState> {
    try {
        const response = await fetch(CUSTOM_DOMAIN_BRANDING_URL, { signal: AbortSignal.timeout(timeoutMs) });
        if (response.status === 404) {
            return { kind: 'notFound' };
        }
        if (!response.ok) {
            return { kind: 'unavailable' };
        }

        const result = (await response.json()) as Result<ApiBranding>;
        return result.data ? { kind: 'loaded', branding: result.data } : { kind: 'unavailable' };
    } catch (error) {
        console.warn('Domain branding could not be loaded, starting with the default look', error);
        return { kind: 'unavailable' };
    }
}
